/**
 * Created by Kamil.Adamuszek on 2017-04-14.
 */
/**
 * Validation method that test if the field is valid against a regular expression.
 */
export var regular = function (value, element) {
    var expression = element.dataset.regular || '';
    expression.replace('&apos;', "'");
    var regularExpression = new RegExp(expression);
    return regularExpression.test(value);
};
